import React from 'react';

// 限定输入字符串长度最大长度的插件
export const useInputLengthPlugin = (basicHooks, props) => {
    const {
        props: basicProps,
        ...other
    } = basicHooks;

    const curLen = basicProps.value ? basicHooks.value.length : 0;

    const valid = curLen <= props.maxLen;

    const checkValid = () => {
        const res = basicHooks.checkValid();

        if (res) {
            if (valid) {
                basicHooks.setStatus('');
                return true;
            }
            basicHooks.setStatus('error');
            return false;
        }
        return res;
    };

    React.useEffect(() => {
        if (curLen > props.maxLen) {
            basicHooks.setStatus('error');
        }
    }, [props.maxLen, curLen, basicProps.value]);

    return {
        props: {
            ...basicHooks,
            maxLen: props.maxLen,
            curLen,
        },
        ...other,
        valid: basicHooks.valid && valid,
        checkValid,
    };
};

// 限定输入字符串字符长度最大长度的插件
export const useInputCharLengthPlugin = (basicHooks, props) => {
    const {
        props: basicProps,
        ...other
    } = basicHooks;

    const curLen = basicProps.value ? calculateCharLength(basicProps.value) : 0;

    const valid = curLen <= props.maxLen;

    const checkValid = () => {
        const res = basicHooks.checkValid();

        if (res) {
            if (valid) {
                basicHooks.setStatus('');
                return true;
            }
            basicHooks.setStatus('error');
            return false;
        }
        return res;
    };

    React.useEffect(() => {
        if (curLen > props.maxLen) {
            basicHooks.setStatus('error');
        }
    }, [props.maxLen, curLen, basicProps.value]);

    return {
        props: {
            ...basicHooks,
            maxLen: props.maxLen,
            curLen,
            calculateLength: calculateCharLength,
            truncate: truncateByChar,
        },
        ...other,
        valid: basicHooks.valid && valid,
        checkValid,
    };
};

// 限定数字输入大小范围的插件
export const useInputNumberRangePlugin = (basicHooks, props) => {
    const {
        props: basicProps,
        ...other
    } = basicHooks;

    const num = Number(basicProps.value);

    const valid = num !== undefined && (props.min === undefined || num > props.min) && (props.max === undefined || num <= props.max);

    const checkValid = () => {
        const res = basicHooks.checkValid();

        if (res) {
            if (valid) {
                basicHooks.setStatus('');
                return true;
            }
            basicHooks.setStatus('error');
            return false;
        }
        return res;
    };

    return {
        props: {
            ...basicHooks,
            min: props.min,
            max: props.max,
        },
        ...other,
        valid: basicHooks.valid && valid,
        checkValid,
    };
};

// 超过最大长度直接截断输入的插件
export const useInputMaxLengthPlugin = (basicHooks, props) => {
    const {
        props: basicProps,
        ...other
    } = basicHooks;

    return {
        props: {
            ...basicProps,
            maxLength: props.maxLength,
        },
        ...other,
    };
};

// 超过最大字符长度直接截断输入的插件
export const useInputMaxCharLengthPlugin = (basicHooks, props) => {
    const {
        props: basicProps,
        ...other
    } = basicHooks;

    return {
        props: {
            ...basicProps,
            maxLength: props.maxLength,
            calculateLength: calculateCharLength,
            truncate: truncateByChar,
        },
        ...other,
    };
};

const calculateCharLength = (text) => {
    if (text == undefined) {
        return 0;
    }
    var valueLength = 0;
    for (var i = 0; i < text.length; i++) {
        var c = text.charCodeAt(i);
        if (c >= 0 && c <= 128) {
            valueLength += 1;
        } else {
            valueLength += 2;
        }
    }
    return valueLength;
};

const truncateByChar = (text, maxLength) => {
    if (_.isEmpty(text)) {
        return text;
    }

    let length = 0;
    let newArray = [];
    _.forEach(_.split(text, ''), char => {
        if (char) {
            length += calculateCharLength(char);
            if (length <= maxLength) {
                newArray.push(char);
            } else {
                return false;
            }
        }
    });
    return _.join(newArray, '');
};